import AOS from 'aos';
document.addEventListener('DOMContentLoaded', function () {
    AOS.init({
        duration: 500,
        once: true,
    });
});
